var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{attrs:{"id":(_vm.uniqueName ? _vm.uniqueName : _vm.divName)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }